import React from 'react';
import {NotificationManager} from 'react-notifications';
import * as userManage from './userManagements'
import addresses from './addresses.json';

//const urlPrefix = 'http://tolitonApi.alireza-azizi.ir/';
//const urlPrefix = 'http://tolitonApiEn.alireza-azizi.ir/';
//const urlPrefix = 'http://45.82.137.139/';
//const urlPrefix = 'http://api.toliton.ir/';
const urlPrefix = addresses.ServerUrl;

const apiPrefix = `${urlPrefix}api/`;

const checkResponse = async (response) => {
    switch (response.status) {
        case 400:
        case 406:
            const res = await response.json();
            NotificationManager.error(res.Message, res.Type);
            break;
        case 401:
            userManage.logout();
            break;
        case 403:
            NotificationManager.error('دسترسی شما به این بخش غیر مجاز می باشد.', 'خطای دسترسی');
            break;
        case 404:
            NotificationManager.error('آدرس سرویس یافت نشد.', 'خطای سیستمی');
            break;
        case 500:
            NotificationManager.error('خطایی در سرور رخ داده است.', 'خطای سیستمی');
            break;
    }
    return response;
}

const get = async (url) => {
    let responseResult = await fetch(apiPrefix + url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        },
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // no-referrer, *client
    })
        .then(async response => {
            return await checkResponse(response);
        });
    return responseResult;
}

const post = async (url, data) => {
    // Default options are marked with *
    let responseResult = await fetch(apiPrefix + url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        },
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // no-referrer, *client
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    })
        .then(async response => {
            return await checkResponse(response);
        });

    return responseResult;
}

const postForm = async (url, data) => {
    let responseResult = await fetch(apiPrefix + url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        },
        // manual, *follow, error
        referrer: 'no-referrer', // no-referrer, *client
        body: data, // body data type must match "Content-Type" header
    })
        .then(async response => {
            return await checkResponse(response);
        });

    return responseResult;
}


export {urlPrefix, get, post, postForm};





// WEBPACK FOOTER //
// ./engine/dataServices.js